module.exports = __webpack_public_path__ + "img/story047.349ff0cb.webp";